import { Component, input, Input, InputSignal } from '@angular/core';
import {
  OccupationOfLanePlacementConstructionObjectsStageForm
} from '../../forms/occupation-of-lane-placement-construction-objects-stage.form';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';
import { DatePickerComponent } from '../../../../../../../../common/date-picker/date-picker.component';
import {
  ExposedMapControlComponent
} from '../../../../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { ParcelsCrudComponent } from '../../../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { NgxMaskDirective } from 'ngx-mask';
import {
  RoadControlsSetComponent
} from '../../../../../common/components/road-controls-set/road-controls-set.component';

@Component({
  selector: 'app-occupation-of-lane-placement-construction-objects-stage-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    DatePickerComponent,
    ExposedMapControlComponent,
    ParcelsCrudComponent,
    NgxMaskDirective,
    RoadControlsSetComponent
  ],
  templateUrl: './occupation-of-lane-placement-construction-objects-stage-form.component.html'
})
export class OccupationOfLanePlacementConstructionObjectsStageFormComponent {
  @Input()
  public label: string = '';

  @Input()
  public form: OccupationOfLanePlacementConstructionObjectsStageForm | undefined;

  @Input()
  public canRemoveStage = true;

  public serviceId: InputSignal<string | null> = input<string | null>(null);
}
